import { useCallback, useEffect, useState } from 'react'
import { appStorageKey } from '../../lib/appStorage'

/**
 * Sidebar daralt/genişlet tercihi için localStorage anahtarı. Uygulama ön ekli (062 research D7a) —
 * **istisna yoktur**: oturuma bağlı olmayan tercihler de ön ek alır, böylece "hangi anahtar ön ek alır?"
 * sorusu ileride tekrar sorulmaz (bkz. `appStorage.ts`). Bedeli: `clearAppSession` çağrılan **her**
 * geçişte (persona değiştirme **ve** normal kurumsal çıkış dahil) bu tercih de sıfırlanır — bilinçli;
 * "oturum ötesi kalıcı" ifadesi yalnız normal sayfa/sekme yenilemesi için geçerlidir, açık bir çıkıştan
 * sağ çıkmaz.
 */
const STORAGE_KEY = appStorageKey('sidebar-collapsed')

/** localStorage'dan başlangıç değerini senkron okur (ilk render doğru genişlik → CLS yok). */
function readInitial(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    // private mode vb. — erişilemezse varsayılan açık (false)
    return false
  }
}

export interface SidebarCollapsed {
  /** true = ikon-ray (kapalı); false = geniş (açık). */
  collapsed: boolean
  /** Durumu tersine çevirir ve kalıcılaştırır. */
  toggle: () => void
}

/**
 * Sidebar'ın daraltılmış/açık tercihini yönetir ve `localStorage`'da kalıcılaştırır (017 FR-014).
 * Kabuk hook'u olduğundan `app/layout` altında, `useActiveMenu` ile eş konumda tutulur.
 */
export function useSidebarCollapsed(): SidebarCollapsed {
  const [collapsed, setCollapsedState] = useState<boolean>(readInitial)

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0')
    } catch {
      // yazılamazsa sessizce React state'te kalır
    }
  }, [collapsed])

  const toggle = useCallback(() => setCollapsedState((prev) => !prev), [])

  return { collapsed, toggle }
}
